module.exports = __webpack_public_path__ + "static/img/logo-2x.8c5d9b3f.webp";